import { render, staticRenderFns } from "./UpdateViagemDialog.vue?vue&type=template&id=3878cb6e&"
import script from "./UpdateViagemDialog.vue?vue&type=script&lang=js&"
export * from "./UpdateViagemDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports